import { render, staticRenderFns } from "./FaceDirectionResultEffectIconSuccess.vue?vue&type=template&id=557fda7d&scoped=true&"
import script from "./FaceDirectionResultEffectIconSuccess.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectIconSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./FaceDirectionResultEffectIconSuccess.vue?vue&type=style&index=0&id=557fda7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557fda7d",
  null
  
)

export default component.exports